"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { RatingStats } from "@/entities/IProfile";
import UserPageRepModifyModal from "@/components/user/rep/modify-rep/UserPageRepModifyModal";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepRepsTableItem(t0) {
  const $ = _c(43);
  const {
    rep,
    profile,
    canEditRep,
    maxRep
  } = t0;
  const [isEditRepModalOpen, setIsEditRepModalOpen] = useState(false);
  let t1;
  if ($[0] !== canEditRep) {
    t1 = () => {
      if (canEditRep) {
        setIsEditRepModalOpen(true);
      }
    };
    $[0] = canEditRep;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onTableClick = t1;
  const progressPercent = maxRep > 0 ? Math.abs(rep.rating) / maxRep * 100 : 0;
  const hoverClass = canEditRep ? "group-hover:tw-from-[#12141a]/60 group-hover:tw-to-[#0d0f13]/60 group-hover:tw-border-white/[0.16]" : "";
  const t2 = canEditRep ? "tw-cursor-pointer tw-group" : "tw-group";
  const t3 = `${"tw-py-2.5 sm:tw-py-3 tw-px-4 tw-bg-gradient-to-r tw-from-[#0f1014]/40 tw-to-[#0A0A0C]/40 tw-border-y tw-border-solid tw-border-white/[0.08] sm:tw-border-white/[0.04] tw-border-x-0 tw-transition-all tw-duration-200 tw-ease-out"} ${hoverClass} tw-rounded-l-lg tw-border-l tw-border-l-white/[0.08] sm:tw-border-l-white/[0.04]`;
  let t4;
  if ($[2] !== rep.category) {
    t4 = <div className="tw-max-w-[12rem] lg:tw-max-w-[20rem] tw-truncate tw-text-sm lg:tw-text-base tw-font-semibold tw-text-iron-100 group-hover:tw-text-white tw-transition-colors tw-mb-2">{rep.category}</div>;
    $[2] = rep.category;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `${progressPercent}%`;
  let t6;
  if ($[4] !== t5) {
    t6 = <div className="tw-h-1 tw-w-full tw-max-w-[16rem] tw-bg-white/[0.04] tw-rounded-full tw-overflow-hidden"><div className="tw-h-full tw-bg-gradient-to-r tw-from-blue-500/50 tw-to-blue-400/30 tw-rounded-full tw-shadow-[0_0_6px_rgba(59,130,246,0.25)]" style={{
        width: t5
      }} /></div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t6) {
    t7 = <td className={t3}>{t4}{t6}</td>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${"tw-py-2.5 sm:tw-py-3 tw-px-4 tw-bg-gradient-to-r tw-from-[#0f1014]/40 tw-to-[#0A0A0C]/40 tw-border-y tw-border-solid tw-border-white/[0.08] sm:tw-border-white/[0.04] tw-border-x-0 tw-transition-all tw-duration-200 tw-ease-out"} ${hoverClass} tw-text-right`;
  let t9;
  if ($[10] !== rep.rating) {
    t9 = formatNumberWithCommas(rep.rating);
    $[10] = rep.rating;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <span className="tw-text-sm lg:tw-text-base tw-font-semibold tw-text-iron-300 group-hover:tw-text-iron-200 tw-transition-colors">{t9}</span>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t8) {
    t11 = <td className={t8}>{t10}</td>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `${"tw-py-2.5 sm:tw-py-3 tw-px-4 tw-bg-gradient-to-r tw-from-[#0f1014]/40 tw-to-[#0A0A0C]/40 tw-border-y tw-border-solid tw-border-white/[0.08] sm:tw-border-white/[0.04] tw-border-x-0 tw-transition-all tw-duration-200 tw-ease-out"} ${hoverClass} tw-text-right ${canEditRep ? "" : "tw-rounded-r-lg tw-border-r tw-border-r-white/[0.08] sm:tw-border-r-white/[0.04]"}`;
  let t13;
  if ($[17] !== rep.contributor_count) {
    t13 = formatNumberWithCommas(rep.contributor_count);
    $[17] = rep.contributor_count;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13) {
    t14 = <span className="tw-text-xs lg:tw-text-sm tw-font-normal tw-text-iron-400 group-hover:tw-text-iron-300 tw-transition-colors">{t13}</span>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t14) {
    t15 = <td className={t12}>{t14}</td>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== canEditRep || $[25] !== hoverClass || $[26] !== rep.rater_contribution) {
    t16 = canEditRep && <td className={`${"tw-py-2.5 sm:tw-py-3 tw-px-4 tw-bg-gradient-to-r tw-from-[#0f1014]/40 tw-to-[#0A0A0C]/40 tw-border-y tw-border-solid tw-border-white/[0.08] sm:tw-border-white/[0.04] tw-border-x-0 tw-transition-all tw-duration-200 tw-ease-out"} ${hoverClass} tw-rounded-r-lg tw-border-r tw-border-r-white/[0.08] sm:tw-border-r-white/[0.04] tw-text-right`}>{rep.rater_contribution ? <span className={`tw-text-sm tw-font-semibold tw-transition-colors ${rep.rater_contribution > 0 ? "tw-text-primary-400/90 group-hover:tw-text-primary-400" : "tw-text-rose-400"}`}>{formatNumberWithCommas(rep.rater_contribution)}</span> : <span className="tw-text-sm tw-font-semibold tw-text-white/15 group-hover:tw-text-white/25 tw-transition-colors">-</span>}</td>;
    $[24] = canEditRep;
    $[25] = hoverClass;
    $[26] = rep.rater_contribution;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== onTableClick || $[29] !== t11 || $[30] !== t15 || $[31] !== t16 || $[32] !== t2 || $[33] !== t7) {
    t17 = <tr className={t2} onClick={onTableClick}>{t7}{t11}{t15}{t16}</tr>;
    $[28] = onTableClick;
    $[29] = t11;
    $[30] = t15;
    $[31] = t16;
    $[32] = t2;
    $[33] = t7;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== canEditRep || $[36] !== isEditRepModalOpen || $[37] !== profile || $[38] !== rep.category) {
    t18 = canEditRep && isEditRepModalOpen && <UserPageRepModifyModal profile={profile} category={rep.category} onClose={() => setIsEditRepModalOpen(false)} />;
    $[35] = canEditRep;
    $[36] = isEditRepModalOpen;
    $[37] = profile;
    $[38] = rep.category;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t17 || $[41] !== t18) {
    t19 = <>{t17}{t18}</>;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
}